'use client'

;!function(){try{var e="undefined"!=typeof globalThis?globalThis:"undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:offsoo-landing":true});}catch(e){}}();import type { ComponentProps } from 'react'

import { useCalendly } from '@/components/integrations/calendly/calendly-provider'
import { useIntercom } from '@/components/integrations/intercom/intercom-provider'

type FooterContactItemProps = {
  label: string
  kind?: 'chat' | 'demo'
  className?: string
} & ComponentProps<'li'>

export function FooterContactItem({ label, kind, className, ...props }: FooterContactItemProps) {
  const { open: openIntercom } = useIntercom()
  const { open: openCalendly, warmup } = useCalendly()
  const actionKind: 'chat' | 'demo' = kind ?? (label.toLowerCase().includes('chat') ? 'chat' : 'demo')
  const isDemo = actionKind === 'demo'

  return (
    <li className={className} {...props}>
      <button
        type="button"
        onClick={() => (isDemo ? openCalendly({ location: 'footer' }) : openIntercom())}
        onPointerEnter={isDemo ? warmup : undefined}
        onFocus={isDemo ? warmup : undefined}
        className="cursor-pointer text-left text-mist-700 hover:text-mist-950 dark:text-mist-400 dark:hover:text-white"
      >
        {label}
      </button>
    </li>
  )
}
